module.exports = __webpack_public_path__ + "static/media/logotakeat.6eeaa66f.png";